import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const QuestionLink = styled(Link)`
  color: currentColor;

  &:hover {
    color: ${({ theme }) => theme.linkColor};
  }
`;
